import { TextField, Button, Typography } from "@mui/material"
import ReactQuill from "react-quill"
import { slugify } from "../../Utils/slugify"

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],   // enable image & video
    ["clean"]
  ]
};


function ProjectForm({project,setProject,onSubmit,editStatus}){
 
const handleChange = (e) => {
  const { name, value } = e.target;

  setProject((prev) => {
    const updatedProject = {
      ...prev,
      [name]: value,
    };

    // auto-generate slug from title
    if (name === "title") {
      updatedProject.slug = slugify(value);
    }

    return updatedProject;
  });
};

const handleImage=(e)=>{

const file = e.target.files[0]

const reader = new FileReader()

reader.onload=()=>{

setProject({
...project,
image:reader.result
})

}

reader.readAsDataURL(file)


}
console.log(project)

return (
  <>
   <style>
{`
.ql-container {
  min-height: 500px;
}

.ql-editor {
  min-height: 500px;
}
`}
</style>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      padding: "30px 20px",
      background:
        "linear-gradient(to bottom right, #eef5fb, #f8f9fc)",
      minHeight: "100vh",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "1100px",
        background: "#fff",
        borderRadius: "22px",
        padding: "35px",
        boxShadow: "0 12px 35px rgba(0,0,0,0.08)",
      }}
    >
      {/* TITLE */}
      <Typography
        sx={{
          fontSize: "32px",
          fontWeight: 700,
          color: "#1e293b",
          mb: 1,
        }}
      >
        {editStatus ? "Edit Project" : "Create New Project"}
      </Typography>

      <Typography
        sx={{
          fontSize: "14px",
          color: "#64748b",
          mb: 4,
        }}
      >
        Create and manage your project content with rich text editor
      </Typography>

      {/* FORM GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "24px",
        }}
      >
        {/* TITLE */}
        <TextField
          label="Project Title"
          name="title"
          fullWidth
          value={project.title || ""}
          onChange={handleChange}
          variant="outlined"
          sx={{
            // Label font size
    "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
            },
            "& .MuiOutlinedInput-root.Mui-focused fieldset": {
              borderColor: "#0078c9",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#0078c9",
            },
             "& .MuiInputBase-input": {
      fontSize: "16px",
    },
          }}
        />

        {/* AUTHOR */}
        <TextField
          label="Author"
          name="author"
          fullWidth
          value={project.author || ""}
          onChange={handleChange}
          variant="outlined"
          sx={{
            // Label font size
    "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
            },
            "& .MuiOutlinedInput-root.Mui-focused fieldset": {
              borderColor: "#0078c9",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#0078c9",
            },
             "& .MuiInputBase-input": {
      fontSize: "16px",
    },
          }}
        />
      </div>

      {/* DESCRIPTION */}
      <TextField
        label="Short Description"
        name="description"
        fullWidth
        multiline
        rows={4}
        margin="normal"
        value={project.description  || ""}
        onChange={handleChange}
        sx={{
          mt: 3,
          // Label font size
    "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
          },
          "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderColor: "#0078c9",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#0078c9",
          },
           "& .MuiInputBase-input": {
      fontSize: "16px",
    },
        }}
      />

      {/* IMAGE UPLOAD */}
      <div
        style={{
          marginTop: "30px",
          padding: "24px",
          border: "2px dashed #cbd5e1",
          borderRadius: "18px",
          background: "#f8fbff",
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 600,
            color: "#1e293b",
            mb: 1,
          }}
        >
          Upload Featured Image
        </Typography>

        <Typography
          sx={{
            fontSize: 13,
            color: "#64748b",
            mb: 2,
          }}
        >
          Recommended size: 1200 x 600 px
        </Typography>

        <input
          type="file"
          onChange={handleImage}
        />

        {project.image && (
          <div
            style={{
              marginTop: "20px",
            }}
          >
            <img
              src={project.image}
              alt="preview"
              style={{
                width: "220px",
                borderRadius: "14px",
                border: "3px solid white",
                boxShadow:
                  "0 8px 20px rgba(0,0,0,0.12)",
              }}
            />
          </div>
        )}
      </div>

      {/* CONTENT */}
      <div style={{ marginTop: "35px" }}>
        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 700,
            color: "#1e293b",
            mb: 2,
          }}
        >
          Project Content
        </Typography>

        <style>
          {`
            .ql-toolbar {
              border-radius: 14px 14px 0 0;
              border: 1px solid #dbe3ec;
              background: #f8fbff;
            }

            .ql-container {
              min-height: 500px;
              border-radius: 0 0 14px 14px;
              border: 1px solid #dbe3ec;
              font-size: 16px;
              background: white;
            }

            .ql-editor {
              min-height: 500px;
            }

            .ql-editor:focus {
              border-color: #0078c9;
            }
          `}
        </style>

        <ReactQuill
          value={project.content || ""}
          onChange={(value) =>
            setProject({
              ...project,
              content: value,
            })
          }
          modules={modules}
          theme="snow"
        />
      </div>

      {/* ACTION BUTTON */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "40px",
        }}
      >
        <Button
          variant="contained"
          onClick={onSubmit}
          sx={{
            height: "52px",
            minWidth: "190px",
            borderRadius: "12px",
            fontWeight: 700,
            fontSize: "15px",
            textTransform: "none",
            background:
              "#0078c9",
            boxShadow:
              "0 10px 25px rgba(0,120,201,0.25)",
            ":hover": {
              background:
                "#0078c9",
            },
          }}
        >
          {editStatus ? "Update Project" : "Publish Project"}
        </Button>
      </div>
    </div>
  </div>
  </>

);

}

export default ProjectForm